import Isotope from 'isotope-layout'
import imagesloaded from 'imagesloaded'

/**
 * About component
 * @author Dayne Coulson-Hoffacker
 */
export default class WorkItems {
  /**
   * Constructs a new WorkItems instance.
   * @param {Object} options - Options object.
   * @param {HMTLElement} options.element - Container element.
   */
  constructor (options) {
    this.element = options.element
    this.grid = this.element.querySelector('.grid')
    this.iso
    imagesloaded( this.grid, () => {
      this.iso = new Isotope( this.grid, {
        itemSelector: '.grid-item',
        layoutMode: 'masonry',
        masonry: {
          gutter: '.gutter-size'
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./components/work-items/index.js